import React, {createContext, useContext} from 'react';

import {
  EMobilityToolsFeatureAppComponentLibrary,
  mockOptionalEMobilityToolsFeatureAppComponentLibrary,
} from './types';

export const COMPONENT_LIBRARY_ERROR_CODE_MISSING_COMPONENT =
  'MissingWhiteLabelComponent';

export const ComponentLibraryContext =
  createContext<EMobilityToolsFeatureAppComponentLibrary | undefined>(
    undefined
  );

export const useComponentLibrary =
  (): EMobilityToolsFeatureAppComponentLibrary => {
    const componentLibrary = useContext(ComponentLibraryContext);

    if (!componentLibrary) {
      throw new Error('Component library not found in current context');
    }

    return componentLibrary;
  };

export const useComponent = <
  K extends keyof EMobilityToolsFeatureAppComponentLibrary
>(
  componentType: K
): EMobilityToolsFeatureAppComponentLibrary[K] => {
  const componentLibrary = useComponentLibrary();

  if (!componentLibrary[componentType]) {
    const errText = `Component "${componentType}" not found in provided component library`;

    if (
      !(componentType in mockOptionalEMobilityToolsFeatureAppComponentLibrary)
    ) {
      // eslint-disable-next-line no-console -- this is not a debug message
      console.error(errText);
    }

    const ErrorComponent = (): JSX.Element => <>{errText}</>;

    ErrorComponent.displayName = COMPONENT_LIBRARY_ERROR_CODE_MISSING_COMPONENT;

    return ErrorComponent as any;
  }

  return componentLibrary[componentType];
};
